import React, {createContext, useContext, useEffect, useState} from 'react';
import { useSearchParams } from 'react-router-dom';
import { jsonToStyle, mapStylesFromMerchant, mapStylesFromMerchant1,PaymentModes } from '../../utils';
import {
  EncryptedPubKey,
  PaymentContext,
  PaymentInfoContext,
  PaymentRequest,
  PaymentMode,
  WalletItems,
  WaitRedirectContext
} from '../../App';
import Loader from '../../components/Loader';
import PaymentForm from '../../components/PaymentForm';
import Layout from '../../layouts/Layout';
import axios from '../../api/axios';
import { paymentStatuses } from '../../constants/paymentStatuses';
import { useFormik } from 'formik';
import MessageCaller from '../../components/MessageCaller';
import RequiresActionModal from '../../components/RequiresActionModal';
import { errorHandler } from '../../utils/errorHandler';
import useBuyNowPaymentMethod from '../../hooks/useBuyNowPaymentMethod';
import usePaymentMethod from '../../hooks/usePaymentMethod';
import { PaymentInfoMapper } from "../../models/mapper/paymentInfoMapper";
import './styles.scss';
import {PaymentMethodsTypes, UK_POSTAL_CODE, US_ZIP_CODE, APM_CODES, ApmsTypes} from "../../constants";
import { useTranslation } from 'react-i18next';
import {checkoutComEvents} from "../../events/checkoutCom.events";
import {ProviderTypeContext} from "../../containers/InitCheckoutContainer";

export const LoadingContext = createContext(false);
export const CreatePaymentContext = createContext(null);
const Checkout = () => {
  const paymentMode = useContext(PaymentMode);
  const payment = useContext(PaymentContext);
  const paymentInfo = useContext(PaymentInfoContext);
  const encryptedPubKey = useContext(EncryptedPubKey);
  const paymentRequest = useContext(PaymentRequest);
  const walletItems = useContext(WalletItems);
  const { setWaitRedirect } = useContext(WaitRedirectContext);
  const {providerType} = useContext(ProviderTypeContext);
  const [isPaymentActionSidebarVisible, setIsPaymentActionSidebarVisible] = useState(true);
  const [isSubmited, setIsSubmited] = useState(false);

  const providerTypes = {
    'checkout': {
      code: 'checkout',
      name: 'Checkout'
    },
    'evypay': {
      code: 'evypay',
      name: 'EvyPay'
    },
  }
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [currencyList, setCurrencyList] = useState();
  const [warningMessage, setWarningMessage] = useState('');
  const [currentPaymentSystem, setCurrentPaymentSystem] = useState(null);
  const [walletItem, setWalletItem] = useState();

  useEffect(() => {
    if(providerType && providerTypes[providerType.toLowerCase()])
        setCurrentPaymentSystem(providerTypes[providerType.toLowerCase()])
  }, [providerType])

  const buyNowPaymentMethod = useBuyNowPaymentMethod();
  const [errorString, setErrorString] = useState();
  const { t } = useTranslation();
  let required = <>{t('Required_Fields')}</>;
  let zipReq = <>{t('This_field_is_required')}</>;

  const isRequiredWithoutWallet = ['checkout', 'evypay'].includes(currentPaymentSystem?.code) && !walletItem;

  const formik = useFormik({
    initialValues: {
      cardName: '',
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      zip: '',
      agree: false,
      currency: paymentInfo?.currency || '',
      country: paymentInfo?.country || '',
      city: paymentInfo?.payerCity || '',
      amount: paymentInfo?.amount || 0,
      paymentSchedule: paymentInfo?.paymentSchedule,
      isFullOrderAmountPaid: !(paymentInfo?.paymentSchedule?.length && paymentInfo?.type === PaymentModes.PayLater),
      saveCard: false,
      email: paymentInfo?.payerEmail || '',
      phone: paymentInfo?.payerPhone || '',
      dialCode: '',
      dialCountryCode: '',
      address: paymentInfo?.payerAddress || '',
      state: '',
      metadata: null,
    },
    validate: (values) => {
      let pCode = formik.values.country === 'GB' ? `${t('Postal')} ${t('code')}` : `${t('ZIP')}`
      let errors = {};
      const isApm = APM_CODES.includes(currentPaymentSystem.code);

      if (!values.cardName && isRequiredWithoutWallet) {
        errors.cardName = required;
      }
      if (!values.cardNumber.complete && isRequiredWithoutWallet) {
        errors.cardNumber = required;
      }
      if (!values.cardExpiry.complete && isRequiredWithoutWallet) {
        errors.cardExpiry = required;
      }
      if (!values.cardCvc.complete && isRequiredWithoutWallet) {
        errors.cardCvc = required;
      }
      if (!values.agree && !payment && isRequiredWithoutWallet) {
        errors.agree = required;
      }
      if ((values.country === 'US' || values.country === 'GB')
          && paymentMode!=PaymentModes.Token
          && !values.zip.match(values.country === 'US' ? US_ZIP_CODE : UK_POSTAL_CODE)
          && !isApm) {
        errors.zip = `${t('Please_enter_correct')} ${pCode}`;
      }
      if ((values.country === 'US' || values.country === 'GB')
          && paymentMode != PaymentModes.Token && !values.zip && !isApm) {
        errors.zip = zipReq;
      }

      errors = validateApm(values, errors, isApm);

      if ((values.cardNumber.complete && values.cardExpiry.complete
        && values.cardName && values.cardCvc.complete) || walletItem) {
        if ((values.country === 'US' || values.country === 'GB') && paymentMode!=PaymentModes.Token) {
          if (values.zip && !formik.errors?.zip) {
            parent.postMessage(
              {
                type: 'ON_FORM_COMPLETED',
                value: 'Form has been validated.'
              },
              '*'
            );
          } else {
            parent.postMessage(
              {
                type: 'INVALID_FORM',
                value: 'Form has not been validated.'
              },
              '*'
            );
          }
        }
        else {
          parent.postMessage(
            {
              type: 'ON_FORM_COMPLETED',
              value: 'Form has been validated.'
            },
            '*'
          );
        }
      }
      else {
        parent.postMessage(
          {
            type: 'INVALID_FORM',
            value: 'Form has not been validated.'
          },
          '*'
        );
      }
      return errors;
    },
    onSubmit: async () => {
      if (APM_CODES.includes(currentPaymentSystem.code)) {
        await handleApmSubmit();
      } else {
        await handleSubmit();
      }
    },
    enableReinitialize: true
  });

  const validateApm = (values, errors, isApm) => {
    if (!isApm)
      return errors;

    const cardNameApms = [ApmsTypes.Giropay, ApmsTypes.Przelewy24, ApmsTypes.PostFinance];
    if (!values.cardName && cardNameApms.includes(currentPaymentSystem.code)) {
      errors.cardName = required;
    }
    if (currentPaymentSystem.code === ApmsTypes.Giropay) {
      if (!values.zip) {
        errors.zip = zipReq;
      }
      if (!values.city) {
        errors.city = zipReq;
      }
    }

    if (currentPaymentSystem.code === ApmsTypes.Przelewy24 && !values.email) {
      errors.email = required;
    }
    if (currentPaymentSystem.code === ApmsTypes.Tamara) {
      const phone = values.phone?.replace('+', '');
      if (!phone) {
        errors.phone = required;
      }
      if (values.dialCountryCode !== values.country) {
        errors.phone = <>{t('Phone_country_error')}</>;
      }
      if (!values.address) {
        errors.address = required;
      }
      if (!values.city) {
        errors.city = required;
      }
      if (!values.state) {
        errors.state = required;
      }
      if (!values.zip) {
        errors.zip = zipReq;
      }
    }

    return errors;
  }

  useEffect(() => {
    const unsubscribeReInit = checkoutComEvents.on("reInitialize", (e) => {
      formik.resetForm();
    });

    const unsubscribeOnValidationChanged = checkoutComEvents.on("onValidationChanged", (e) => {
      const { isValid, isEmpty, element, value } = e;

      const errorsMessages = {
        'card-number': (empty, valid) => {
            if (empty) return 'Card number is required';
            if (!valid) return 'Card number is invalid';
        },
        'expiry-date': (empty, valid) => {
          if (empty) return 'Card expiry is required';
          if (!valid) return 'Card expiry is invalid';
        },
        'cvv': (empty, valid) => {
          if (empty) return 'Card cvc is required';
          if (!valid) return 'Card cvc is invalid';
        },
      }

      const elementMapToFormik = {
        'card-number': 'cardNumber',
        'expiry-date': 'cardExpiry',
        'cvv': 'cardCvc',
      }

      const error = errorsMessages[element](isEmpty, isValid);
      formik.setFieldValue(elementMapToFormik[element], {
        value,
        complete: isValid,
        isEmpty,
        ...(error && {
          error: {
            message: error
          }
        })
      });
      formik.setFieldError(elementMapToFormik[element], error);
    });

    return () => {
      unsubscribeOnValidationChanged();
      unsubscribeReInit();
    }
  }, []);

  const { paymentMethod, error } = usePaymentMethod(formik, setLoading, setErrorString, walletItem, currentPaymentSystem);

  useEffect(() => {
    if (error) {
      setErrorString(errorHandler(error));
      payment &&
        parent.postMessage(
          {
            type: 'ON_ERROR',
            value: 'Payment method Stripe Error'
          },
          '*'
        );
    }
  }, [error])

  useEffect(() => {
    setErrorString('');
  }, [currentPaymentSystem]);

  useEffect(() => {
    const unsubscribe = checkoutComEvents.on("frameFocus", (e) => {
      if(errorString){
        setErrorString('');
      }
    });

    return () => {
        unsubscribe();
    }
  }, []);

  useEffect(() => {
    if (paymentRequest) {
      paymentRequest.on('paymentmethod', async (event) => {
        if (event.paymentMethod.card.country !== formik.values.country) {
          await formik.setFieldValue('country', event.paymentMethod.card.country);
          const currencyInfo = await getPayInList(event.paymentMethod.id);
          setCurrencyList(currencyInfo.currencyList);
          setWarningMessage(currencyInfo.warningMessage);
          await formik.setFieldValue('currency', currencyInfo.currencyToPayIn);
        }
      });
    }
  }, [paymentRequest]);

  useEffect(() => {
    if (paymentMethod) {
      (async () => {
        const currencyInfo = await getPayInList(paymentMethod.id);
        await formik.setFieldValue('country', currencyInfo.country.iso);
        const cardCurrency = currencyInfo.currencyList.filter(x => (x.name !== currencyInfo.currencyToPayIn)).map(x => (x.name));
        const sortedCurreny = currencyInfo.currencyList?.sort(function (a, b) {
          return (b.iso - a.iso) ? 1 : -1;
        });
        const isSelectedCurrencyCorrect = sortedCurreny?.find(x => x.iso === formik.values.currency);
        // Need to change here for currency
        if(!isSelectedCurrencyCorrect) {
          await formik.setFieldValue('currency', cardCurrency?.length ? cardCurrency.at(0) : currencyInfo.currencyToPayIn);
        }
        setCurrencyList(sortedCurreny);
        setWarningMessage(currencyInfo.warningMessage);
      })();
    } else {
      setCurrencyList(undefined);
    }
    setLoading(false);
  }, [paymentMethod]);

  useEffect(() => {
    const redirectStatus = searchParams.get('redirect_status');
    const paymentIntent = searchParams.get('payment_intent');
    if (paymentIntent && redirectStatus === 'succeeded' && encryptedPubKey) {
      (async () => {
        const orderData = await orderComplete();
        onSuccessPayment(orderData);
      })();
    }
    if (walletItems && walletItems.length) {
      setWalletItem(walletItems[0]);
    }
  }, [searchParams, encryptedPubKey]);

  const getPayInList = async (paymentMethodId) => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `/payment/pay-in-list?paymentMethodExternalId=${paymentMethodId}&pubKey=${encryptedPubKey}&paymentProviderType=${providerType}`,
        {
          headers: {
            'X-ApiKey': paymentInfo.merchantPubKey
          }
        }
      );
      setLoading(false);
      return data;
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorString(errorHandler(error));
      parent.postMessage(
        {
          type: 'ON_ERROR',
          value: 'Pay-in-List not found error'
        },
        '*'
      );
    }
  };

  const handleSubmit = async (payload) => {
    if(isSubmited) return;

    setIsSubmited(true);
    setErrorString('');
    try {
      const currentPaymentMethod = buyNowPaymentMethod ?? paymentMethod;
      const paymentData = !walletItem
                            ? await createPayment(payload ?? currentPaymentMethod)
                            : await createPaymentByWalletItem(paymentMethod);

      if (paymentData?.confirmation3dsDevelopmentLink) {
        payment && parent.postMessage(
          {
            type: 'ON_3DS_STARTED',
            value: '3DS stated'
          },
          '*'
        );

      }

      const orderData = await orderComplete();

      onSuccessPayment(orderData);
      window.Frames.init();
      formik.resetForm();
      setIsSubmited(false);
    } catch (error) {
      setIsSubmited(false)
      console.error(error);
      payment &&
        parent.postMessage(
          {
            type: 'ON_PAYMENT_FAILED',
            value: { ...error }
          },
          '*'
        );
    }
  };

  const handleApmSubmit = async () => {
    try {
      setErrorString('');
      setLoading(true);

      const payload = {
        pubKey: encryptedPubKey,
        countryIso: formik.values.country,
        brandCode: currentPaymentSystem.code,
        payload: generateApmPayload(),
        capture: paymentInfo?.type !== PaymentModes.Authorize,
      };

      const { data } = await axios.patch('/lpm', payload);

      setLoading(false);

      setWaitRedirect(true);
      checkoutComEvents.emit('paymentCreated', encryptedPubKey)
      setIsPaymentActionSidebarVisible(false);
      const orderData = await orderComplete();

      onSuccessPayment(orderData);
      window.Frames.init();
      formik.resetForm();
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorString(errorHandler(error));
      parent.postMessage(
        {
          type: 'ON_PAYMENT_FAILED',
          value: `${currentPaymentSystem.name} Payment has been Failed`
        },
        '*'
      );
      throw error;
    }
  }

  const generateApmPayload = () => {
    let tempPayload = null;
    const account = formik.values.cardName?.split(' ');
    const firstName = account.length > 0 ? account.slice(0, -1).join(' ') : '';
    const lastName = account.length > 1 ? account.slice(-1).join(' ') : '';

    if (currentPaymentSystem.code == ApmsTypes.Giropay) {
      tempPayload = {
        accountHolder: {
          firstName,
          lastName,
        },
        address: {
          city: formik.values.city,
          zip: formik.values.zip,
          country: formik.values.country,
        }
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.Przelewy24) {
      tempPayload = {
        accountHolder: {
          firstName,
          lastName,
          email: formik.values.email,
        }
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.IDeal) {
      tempPayload = {
        language: paymentInfo?.language,
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.Sofort) {
      tempPayload = {
        languageCode: paymentInfo?.language,
        countryCode: formik.values.country,
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.Tamara) {
      tempPayload = {
        billingAddress: {
          addressLine1: formik.values.address,
          city: formik.values.city,
          state: formik.values.state,
          zip: formik.values.zip,
          country: formik.values.country,
        },
        phone: {
          countryCode: `+${formik.values.dialCode}`,
          number: formik.values.phone.replace(`+${formik.values.dialCode}`, ''),
        }
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.Bancontact || currentPaymentSystem.code == ApmsTypes.Multibanco
              || currentPaymentSystem.code == ApmsTypes.PostFinance) {
      tempPayload = {
        accountHolder: {
          firstName,
          lastName,
        }
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.EPS) {
      tempPayload = {};
    }
    else if (currentPaymentSystem.code == ApmsTypes.AlipayCN) {
      tempPayload = {
        paymentMethodType: PaymentMethodsTypes.AlipayCN,
      };
    }
    else if (currentPaymentSystem.code == ApmsTypes.PayPal) {
      tempPayload = formik.values.metadata;
    }

    return tempPayload ? JSON.stringify(tempPayload) : null;
  }

  const onSuccessPayment = (orderData) => {
    if (!payment) {
      const isAuthOnly = paymentInfo?.type === PaymentModes.Authorize;
      if (
        orderData.status.toLowerCase() == paymentStatuses.Succeeded.toLowerCase() ||
        orderData.status.toLowerCase() == paymentStatuses.Scheduled.toLowerCase() ||
        (isAuthOnly && orderData.status.toLowerCase() == paymentStatuses.RequiresCapture.toLowerCase())
      ) {
        window.location.href = `${paymentInfo.returnUrlSuccess}?tid=${orderData.transactionId}`;
      }
      if (orderData.status.toLowerCase() == paymentStatuses.Canceled.toLowerCase()) {
        window.location.href = `${paymentInfo.returnUrlCancel}?tid=${orderData.transactionId}`;
      }
    }else{
      const obj = {
        type: 'ON_SUCCESS',
        value: { ...orderData }
      };
      // This hack is for 3ds flow.
      setTimeout(() => {
        parent.postMessage(obj, '*');
      }, 2000);
    }
  };

  const createPayment = async (paymentMethod) => {
    setLoading(true);
    try {
      if(paymentMethod?.paymentMethodType === PaymentMethodsTypes.GooglePay
        || paymentMethod?.paymentMethodType === PaymentMethodsTypes.ApplePay) {
        const request = {
          ...paymentMethod,
          pubKey: encryptedPubKey,
          isFullOrderAmountPaid: false,
        }

        const { data } = await axios.patch(`/payment`, request, {
          headers: {
            'X-ApiKey': paymentInfo.merchantPubKey
          }
        });

        setLoading(false);

        setWaitRedirect(true);
        checkoutComEvents.emit('paymentCreated', encryptedPubKey)
        setIsPaymentActionSidebarVisible(false);
        return data;
      }
      const request = {
        paymentMethodId: paymentMethod.id, // Token from checkout form
        paymentProviderType: providerType, //'checkout'
        paymentMethodType: buyNowPaymentMethod ? buyNowPaymentMethod.card.wallet.type : paymentMethod.type, // Should be correct tbd.
        currency: formik.values.currency,
        country: formik.values.country,
        pubKey: encryptedPubKey,
        saveCard: formik.values.saveCard,
        zip: formik.values.zip,
        isFullOrderAmountPaid: formik.values.isFullOrderAmountPaid,
        forceAuth: true,
      };
      if (paymentInfo?.type === PaymentModes.Token)
      {
        request.isFullOrderAmountPaid = false;
      }
      else if (formik.values.isFullOrderAmountPaid) {
        request.isFullOrderAmountPaid = true;
      }

      if (formik?.values?.paymentSchedule) {
        request.paymentSchedule = formik?.values?.paymentSchedule;
      }
      const { data } = await axios.patch(`/payment`, request, {
        headers: {
          'X-ApiKey': paymentInfo.merchantPubKey
        }
      });

      setLoading(false);
      setWaitRedirect(true);
      checkoutComEvents.emit('paymentCreated', encryptedPubKey)
      setIsPaymentActionSidebarVisible(false);
      return data;
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorString(errorHandler(error));
      parent.postMessage(
        {
          type: 'ON_PAYMENT_DATA_POST_ERROR',
          value: 'Payment Patch API has been Failed'
        },
        '*'
      );
      throw error;
    }
  };

  const createPaymentByWalletItem = async (paymentMethod) => {
    setLoading(true);
    try {
      const request = {
        walletItemToken: walletItem.iolpayToken,
        paymentMethodId: paymentMethod.id,
        paymentMethodType: paymentMethod.type,
        currency: formik.values.currency,
        country: formik.values.country,
        pubKey: encryptedPubKey,
        saveCard: false,
        isFullOrderAmountPaid: paymentInfo?.type === PaymentModes.Token ? false : formik.values.isFullOrderAmountPaid,
        forceAuth:true,
        paymentProviderType: providerType,
      };

      if (formik?.values?.paymentSchedule) {
        request.paymentSchedule = formik?.values?.paymentSchedule;
      }
      const { data } = await axios.patch(`/payment/proceed-with-wallet-item`, request, {
        headers: {
          'X-ApiKey': paymentInfo.merchantPubKey,
          'X-CustomerKey': payment?.customerId,
          'X-CustomerSignature': payment?.customerSignature,
        }
      });

      setLoading(false);
      checkoutComEvents.emit('paymentCreated', encryptedPubKey)
      return data;
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorString(errorHandler(error));
      parent.postMessage(
        {
          type: 'ON_PAYMENT_DATA_POST_ERROR',
          value: 'Payment Patch API has been Failed'
        },
        '*'
      );
      throw error;
    }
  };

  const orderComplete = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`/payment/check-status?pubKey=${encryptedPubKey}`);
      const { data: dataInfo } = await axios.get(`/payment-info/${encryptedPubKey}`);

      PaymentInfoMapper.toInfoPayment(dataInfo);
      setLoading(false);
      return {
        ...data,
        ...(((dataInfo?.status || '').toLowerCase() === paymentStatuses.Succeeded.toLowerCase()) && {
            status: dataInfo?.status,
        })
      };
    } catch (error) {
      console.error(error);
      setLoading(false);
      setErrorString(errorHandler(error));
      parent.postMessage(
        {
          type: 'ON_PAYMENT_FAILED',
          value: 'Payment order confirm faild.'
        },
        '*'
      );
      throw error;
    }
  };

  const handleSetWalletItem = (value) => {
    setWalletItem(value);
    if (!value) {
      parent.postMessage(
        {
          type: 'INVALID_FORM',
          value: 'Form has not been validated.'
        },
        '*'
      );
    }
  }

  const handle3dsModal = async () => {
    try {
      const orderData = await orderComplete();

      payment && parent.postMessage(
          {
            type: 'ON_3DS_FINISHED',
            value: '3DS finished'
          },
          '*'
      );

      onSuccessPayment(orderData);

      window.Frames.init();
      formik.resetForm();
    } catch (error) {
      console.error(error);
      payment &&
        parent.postMessage(
          {
            type: 'ON_PAYMENT_FAILED',
            value: { ...error }
          },
          '*'
        );
    }
  }

  return (
    <>
      <Loader loading={loading} />
        <Layout>
          <LoadingContext.Provider value={loading}>
            <CreatePaymentContext.Provider value={handleSubmit}>
                <RequiresActionModal
                    onError={() => {
                        formik.resetForm();
                        setErrorString(t('payment_intent_authentication_failure'));
                    }}
                    paymentInfo={paymentInfo}
                    onPaymentIntentSucceeded={handle3dsModal}
                    encryptedPubKey={encryptedPubKey}
                    withSideBar={isPaymentActionSidebarVisible}
                />
                <PaymentForm
                  formik={formik}
                  currencyList={currencyList}
                  errorString={errorString}
                  currentPaymentSystem={currentPaymentSystem}
                  setCurrentPaymentSystem={setCurrentPaymentSystem}
                  walletItem={walletItem}
                  setWalletItem={handleSetWalletItem}
                  warningMessage={warningMessage}
                />
            </CreatePaymentContext.Provider>
          </LoadingContext.Provider>
        </Layout>
      <MessageCaller handleSubmit={formik.handleSubmit} />
      <style> {paymentInfo?.jsonStyle ? jsonToStyle(mapStylesFromMerchant1(paymentInfo?.jsonStyle)) : paymentInfo?.companyStyle ? jsonToStyle(mapStylesFromMerchant(paymentInfo?.companyStyle)) : null} </style>
    </>
  );
};

export default Checkout;
